//  index.js
//  Project hpi
//
//  Created by Axis Maps on 4/27/2020, 4:02:30 PM
//

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./pool-panel.component'),
  loading: () => null,
});
